import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { RequireAuth } from "@/components/Routing/RequireAuth";

import { CreatePlatformGroupPage } from "./pages/create-or-edit/CreatePlatformGroupPage";
import { EditPlatformGroupPage } from "./pages/create-or-edit/EditPlatformGroupPage";
import { ListPlatformGroupsPage } from "./pages/list/ListPlatformGroupsPage";
import { canListPlatformGroups, canManagePlatformGroups } from "./permissions";
import { platformGroupsRoutes } from "./routes";

export const platformGroupsRoute = [
  {
    path: platformGroupsRoutes.list,
    element: (
      <RequireAuth permission={canListPlatformGroups}>
        <ListPlatformGroupsPage />
      </RequireAuth>
    ),
  },
  {
    path: platformGroupsRoutes.create,
    element: (
      <RequireAuth permission={canManagePlatformGroups}>
        <CreatePlatformGroupPage />
      </RequireAuth>
    ),
  },
  {
    path: platformGroupsRoutes.edit,
    element: (
      <RequireAuth permission={canManagePlatformGroups}>
        <EditPlatformGroupPage />
      </RequireAuth>
    ),
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
